import { createSignal } from '@verclam/pulsar';

/** `null` when no MFA reset is pending confirmation; otherwise the id of the user to confirm. */
const userToResetMfaSignal = createSignal<number | null>(null);

export const setUserToResetMfa = (userId: number | null): void => {
	userToResetMfaSignal.value = userId;
};

export default userToResetMfaSignal;
